import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StandardAutomationPage from "./StandardAutomationPage";
import "./Automation.css";

const AutomationPage = () => (
  <>
    <StandardAutomationPage />
    <ToastContainer position="top-right" autoClose={3000} />
  </>
);

export default AutomationPage;
